import * as React from 'react'
import type { History } from 'history'
import { Router } from 'react-router'

type Props = {
  basename?: string
  children: React.ReactNode
  history: History
}

export const AppRouter = ({ basename, children, history }: Props) => {
  const [state, setState] = React.useState({
    action: history.action,
    location: history.location,
  })

  React.useLayoutEffect(() => history.listen(setState), [history])

  return (
    <Router
      basename={basename}
      location={state.location}
      navigator={history}
      navigationType={state.action}
    >
      {children}
    </Router>
  )
}
